import { render } from "./GlobalMap.vue?vue&type=template&id=71dc27e9&ts=true"
import script from "./GlobalMap.vue?vue&type=script&lang=ts"
export * from "./GlobalMap.vue?vue&type=script&lang=ts"

import "./GlobalMap.vue?vue&type=style&index=0&id=71dc27e9&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__